export const siteSettings = {
  name: "Smart Markets Pro",
  link: "https://smartmarketspro.net",
  email: "support@smartmarketspro.net",
  appLink: "https://app.smartmarketspro.net",
};
